import { convertToAbbr } from "../lib/states"

// parses stringified JSON for company address & formats for display

export default function fixCompnayAddress(
  company_street,
  company_street_number,
  company_zip,
  company_city,
  company_state
) {
  let abbrevState = company_state ? convertToAbbr(company_state)[0].abbr : ""

  let streetAddress = `${company_street_number || ""} ${company_street || ""}`
  let stateAddress = `${company_city ? company_city + "," : ""} ${
    abbrevState ? abbrevState + "," : ""
  } ${company_zip || ""}`
  return [streetAddress, stateAddress]
}
